import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from '@3plearning/react-components';
import { FilterListWrapper, FilterList } from './styled';
import { getTypeSelectList, getSelectedTypeOption } from './assessment-filter-util';
import { useTracking } from '../../analytics';

const AssessmentFilter = ({ types = [], i18n, onSelectOption = () => { }, selectedOption }) => {
  const { trackAssessmentTypeFilter } = useTracking();

  const onTypeSelect = ({ value, label }) => {
    trackAssessmentTypeFilter();
    onSelectOption({ id: value, name: label });
  };

  return (<FilterListWrapper>
    <FilterList>
      <label htmlFor="type">{i18n.t`Type`}</label>
      <DropdownMenu
        className="type"
        key="type"
        options={getTypeSelectList(types)}
        onSelectOption={onTypeSelect}
        selectedOption={getSelectedTypeOption(selectedOption)}
        data-name="type"
      />
    </FilterList>
  </FilterListWrapper>);
};

AssessmentFilter.propTypes = {
  types: PropTypes.array,
  i18n: PropTypes.object,
  onSelectOption: PropTypes.func,
  selectedOption: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number
  ])
};

export default AssessmentFilter;
